import { createTranslator } from "@heylife/i18n";
import { detectLocale } from "../i18n";

/** Shown when Sentry.ErrorBoundary catches a render error in the admin console. */
export function SentryErrorFallback({ resetError }: { error?: unknown; resetError: () => void }) {
  const t = createTranslator(detectLocale()).t;
  return (
    <main className="page narrow" style={{ marginTop: "3rem" }}>
      <div className="card">
        <h1>{t("admin.errorBoundary.title")}</h1>
        <p className="muted">{t("admin.errorBoundary.body")}</p>
        <button type="button" className="btn secondary" onClick={resetError}>
          {t("admin.errorBoundary.retry")}
        </button>
      </div>
    </main>
  );
}
